import apiClient from './client';

export const fetchCaseDecision = async (caseNumber) => {
  const { data } = await apiClient.get(`/api/cases/${caseNumber}/decision`);
  return data;
};

export const upsertCaseDecision = async (caseNumber, payload) => {
  const { data } = await apiClient.post(`/api/cases/${caseNumber}/decision`, payload);
  return data;
};

export const updateDownstreamAction = async (actionId, payload) => {
  const { data } = await apiClient.patch(`/api/downstream-actions/${actionId}`, payload);
  return data;
};
